import { Controller } from "@hotwired/stimulus"

const choices = {
    Excluded: ["Excluded", "bg-secondary-alt text-type-muted-alt"],
    NewDiscounted: ["New discounted", "bg-success text-white"],
    NewFullPrice: ["New full price", "bg-blue-700 text-white"],
}

export class ProductImportSelectionController extends Controller {
    static targets = ["row"]

    rowTargetConnected(row) {
        const button = row.parentElement.querySelector("[data-disposition-button]")
        if (!button) return
        row.hidden = true
        button.hidden = false
        this.render(row)
    }

    cycle(event) {
        const row = event.currentTarget.parentElement.querySelector("select")
        const values = Object.keys(choices)
        this.setChoice(row, values[(values.indexOf(row.value) + 1) % values.length])
    }

    includeAll() {
        for (const row of this.rowTargets) {
            if (row.value === "Excluded") this.setChoice(row, row.parentElement.dataset.defaultDisposition || "NewDiscounted")
        }
    }

    excludeAll() {
        for (const row of this.rowTargets) this.setChoice(row, "Excluded")
    }

    setChoice(row, value) {
        if (row.disabled || row.value === value) return
        row.value = value
        this.render(row)
        this.reprice(row)
        row.dispatchEvent(new Event("change", { bubbles: true }))
    }

    reprice(row) {
        if (row.value === "Excluded") return
        const container = row.closest("tr")
        const selling = container?.querySelector("[data-selling-price]")
        const list = container?.querySelector("[data-list-price]")
        if (!selling || !list) return
        selling.readOnly = row.value === "NewFullPrice"
        if (selling.readOnly) selling.value = ""
        const amount = Number(list.value || list.dataset.listPrice)
        const cents = Math.round((amount + Number.EPSILON) * 100)
        if (!Number.isFinite(cents) || cents <= 0) return
        const fullPrice = cents % 50 === 0 ? cents - 1 : cents
        const target = Math.floor(cents * 9 / 10)
        const upward = 49 + 50 * Math.ceil(Math.max(0, target - 49) / 50)
        const discounted = upward * 100 <= cents * 95 ? upward : upward - 50
        const suggested = row.value === "NewFullPrice" ? fullPrice : discounted
        selling.value = row.value === "NewFullPrice" || suggested <= 0 ? "" : (suggested / 100).toFixed(2)
        selling.placeholder = suggested > 0 ? (suggested / 100).toFixed(2) : "Automatic"
    }

    refreshWarnings() { for (const row of this.rowTargets) this.render(row) }

    render(row) {
        const button = row.parentElement.querySelector("[data-disposition-button]")
        if (!button) return
        const [label, colors] = choices[row.value]
        button.querySelector("span").textContent = label
        button.className = `button button--thin min-w-28 text-xs rounded-none border-transparent whitespace-nowrap hover:brightness-95 focus-visible:outline focus-visible:outline-2 ${colors}`
        button.setAttribute("aria-label", `${row.getAttribute("aria-label")}: ${label}. Activate to change.`)
        const selling = row.closest("tr")?.querySelector("[data-selling-price]")
        if (selling) selling.readOnly = row.value === "NewFullPrice"
        const warnings = row.closest("tr")?.querySelector("[data-catalog-warnings]")
        if (warnings) {
            const text = row.value === "Excluded" ? "" : row.value === "NewFullPrice"
                ? warnings.dataset.fullpriceWarning : warnings.dataset.discountedWarning
            const label = warnings.querySelector("[data-catalog-text]")
            if (label) label.textContent = (text || "").split("\n").filter(line => line !== "Checking Shopify catalog…").join("\n")
            const spinner = warnings.querySelector("[data-catalog-spinner]")
            if (spinner) spinner.hidden = !text?.includes("Checking Shopify catalog…")
        }
    }
}
